import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import Constants from '@usas/ui-web/utils/Constants';

const GetOfficialPositionCertificationTypeProgressionData = (personId, personPositionCertificationRequestId, state, setState) => {
  if (state.isArrayLoading !== true && !state.message) {
    const newState = {
      ...state,
      isArrayLoading: true,
      isArrayLoaded: false,
      message: 'Loading...',
      personId: personId,
      personPositionCertificationRequestId: personPositionCertificationRequestId
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : '';
    const personPositionCertificationRequestIdForUrl = personPositionCertificationRequestId ? encodeURIComponent(personPositionCertificationRequestId) : '';
    const url = `/PositionCertificationTypeProgression/person/${personIdForUrl}/personPositionCertificationRequest/${personPositionCertificationRequestIdForUrl}/nationalapplication`;

    PersonHttpHelper(url, 'GET')
      .then((arrayData) => {
        if (!arrayData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          const data = JSON.parse(JSON.stringify(arrayData));
          const blankPosition = { positionCertificationProgressionId: Constants.DEFAULT_ID };
          data.unshift(blankPosition);
          setState({
            ...newState,
            isArrayLoading: false,
            isArrayLoaded: true,
            arrayData,
            options: data.map((position) => { return { id: position.positionCertificationProgressionId, name: position.positionCertificationProgressionId !== Constants.DEFAULT_ID ? `${position.progressionName || ''}` : '--' } }),
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isArrayLoading: false,
          isArrayLoaded: false,
          message: message
        });
      });
  }
};

export default GetOfficialPositionCertificationTypeProgressionData;